export type Source = "setfan" | "setbio";

export type SourceFilter = Source | "all";

export const setfanColors = [
  "#00DDA8",
  "#3C50B1",
  "#6A38B3",
  "#A224AC",
  "#1489E6",
];

export const setbioColors = [
  "#0095EF",
  "#3C50B1",
  "#6A38B3",
  "#A224AC",
  "#E81DE0",
];
